import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { getStyleObject, StyleObject, SubscriptionOffer } from '@outlaw/core';

@Component({
  selector: 'app-subscription-item',
  templateUrl: './subscription-item.component.html',
  styleUrls: ['./subscription-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionItemComponent {
  @Input() subscription: SubscriptionOffer;
  @Input() interactive = false;
  @Output() subscribeEvent: EventEmitter<SubscriptionOffer> =
    new EventEmitter<SubscriptionOffer>();
  @Output() unsubscribeEvent: EventEmitter<SubscriptionOffer> =
    new EventEmitter<SubscriptionOffer>();

  get hasPrice(): boolean {
    return (
      !this.subscription.active_subscription &&
      this.subscription.price !== '0.00'
    );
  }

  get hasDiscount(): boolean {
    return (
      !this.subscription.active_subscription && !!this.subscription.discount
    );
  }

  get renewInfo(): string {
    const renewInfo = 'Renews every ';
    let result = '';
    if (this.subscription.duration_days === 30) {
      result = `${renewInfo} month`;
    }
    if (this.subscription.duration_days === 365) {
      result = `${renewInfo} year`;
    }

    return result;
  }

  get showUnsubscribeButton(): boolean {
    return (
      (this.subscription.active_subscription ||
        this.subscription.active_trial) &&
      !this.subscription.is_manual_canceled &&
      this.subscription.is_periodic
    );
  }

  get showRenewInfo(): boolean {
    return (
      !this.showUnsubscribeButton &&
      !this.subscription.is_manual_canceled &&
      this.subscription.is_periodic &&
      !!this.renewInfo
    );
  }

  getBackgroundStyleObject(
    subscription: SubscriptionOffer,
    field: keyof SubscriptionOffer,
  ): StyleObject {
    return getStyleObject(subscription, field);
  }

  subscribeClick(): void {
    if (this.interactive) {
      this.subscribeEvent.emit(this.subscription);
    }
  }
}
